import React from 'react';
import Modal from 'react-modal';
import { Localize } from "./localize.js";

const customStyles = {
  content: {
    border: '10px solid rgba(0,0,0,.7)',
    borderRadius: "10px",
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50.1%, -50.1%)',

    overlay: { zIndex: 3 }
  }
};

const customWidth = {
  content: {
    width: "90%"
  }
};

class ModalMessage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      viewport: {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      }
    };
  }

  componentWillMount() {
    Modal.setAppElement('body');
  }

  afterOpen = () => {
    document.getElementsByTagName("body")[0].style.overflowY = "hidden";
  }

  onDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.modalClose) {
      this.props.modalClose(e);
    }

    document.getElementsByTagName("body")[0].style.overflowY = "auto";
  }

  onUpdateViewport = () => {
    this.setState({
      viewport: {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      }
    });
  }

  componentDidMount() {
    window.addEventListener('resize', () => this.onUpdateViewport(), true);
  }

  render() {
    var ret = null;

    if (this.props.modalOpen) {
      var vp = this.state.viewport;

      var minWidth = 640 + "px";
      var maxWidth = 760 + "px";
      var minHeight = 360 + "px";
      var maxHeight = 640 + "px";
      var fontSize = 24;
      var show_full_date = false;

      if (vp.innerWidth < 760) {
        minWidth = (vp.innerWidth - 50) + "px";
        maxWidth = (vp.innerWidth - 20) + "px";
      } else {
      }
      if (vp.innerHeight < 640) {
        minHeight = (vp.innerHeight - 50) + "px";
        maxHeight = (vp.innerHeight - 20) + "px";
      } else {
      }

      var title = this.props.title;
      var body = this.props.body;

      var position = this.props.position;

      var content =
        <div className="modal-content" style={{ borderWidth: 8, border: "8px solid rgba(255,99,71,.6)" }}>
          <div className="modal-header" style={{ position: "relative" }}>
            <h4 className="modal-title">
              <span style={{ fontSize: fontSize, fontWeight: 700, color: "#333", textTransform: "uppercase", fontFamily: 'PT Sans Narrow', fontStyle: "italic", lineHeight: 1 }}>
                {title}
              </span>
            </h4>
            <button type="button" className="close" style={{
              position: "absolute", top: "-5px", right: "-5px", color: "white", opacity: .8, backgroundColor: "tomato", borderRadius: "30px", padding: "3px"
            }}
              onClick={(e) => this.onDismiss(e)}>
              <span aria-hidden="true"><i className="far fa-times-circle fa-2x"></i></span>
              <span className="sr-only">{Localize.L("Close")}</span>
            </button>
          </div>
          <div style={{ padding: "12px" }}>
            {Localize.L(body)}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-lg btn-danger btn-danger-glossy" onClick={(e) => this.onDismiss(e)}>{Localize.L("Ho capito")}</button>
          </div>
        </div>
        ;

      var overlayStyles = {}
      var contentStyles = { maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight };

      if (position != null) {
        contentStyles.top = position.top;
        contentStyles.left = position.left;
        contentStyles.position = position.position;

        overlayStyles = { zIndex: position.zIndex, backgroundColor: "transparent" }
      }

      var modalStyles = { ...customWidth, content: contentStyles, overlay: overlayStyles };
      ret = (
        <Modal
          style={modalStyles}
          closeOnEscape={true}
          onAfterOpen={this.afterOpen}
          className="Modal__Bootstrap modal-dialog"
          closeTimeoutMS={150}
          isOpen={true}
          onRequestClose={this.onDismiss}
        >
          {content}
        </Modal>
      );

    }

    return ret;
  }
}

export { ModalMessage }
